import React, { FC } from 'react';
import styled from 'styled-components';

import { StyledConfirmOrCancelModal } from 'src/presentation/components/pages/shared/rowActions/StyledConfirmOrCancelModal';

type ConfirmSaveModalProps = {
  onCancel: Function;
  onSubmit: Function;
  isVisible: boolean;
};

const ConfirmSaveModal: FC<ConfirmSaveModalProps> = ({ onCancel, onSubmit, isVisible }) => {
  return (
    <>
      {isVisible && (
        <Modal
          cancelText="Cancel"
          data-aid="saveAnalyst"
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitText="Yes, proceed"
          text="The user has been assigned the “analyst” role. This role incurs an additional cost. Would you like to proceed?"
          title="Reminder about the analyst role"
        />
      )}
    </>
  );
};

const Modal = styled(StyledConfirmOrCancelModal)`
  position: fixed;
  width: 100vh;
  height: 100vh;
  z-index: 100;
`;

export default ConfirmSaveModal;
